import { Component } from 'react';
import type { ReactNode } from 'react';

/**
 * SAFE FAILURE STATE — a broken module must never take down the whole
 * shell (sidebar/topbar stay usable). Human-readable message + a Retry
 * action, per "Error states" (#32) — never a raw stack trace to the user,
 * though it's logged to console for a developer to find.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // eslint-disable-next-line no-console
    console.error('Ugarits Command Center — unhandled error in a module:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card" style={{ padding: 20, margin: 20 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>This module hit a problem loading.</div>
          <div style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 12 }}>
            Your other data was not affected — this is isolated to the module that failed.
          </div>
          <button onClick={() => this.setState({ error: null })}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
